import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, Button } from 'antd';

import './CustomModal.scss';

function CustomModal({
  isOpen,
  title,
  width,
  children,
  customFooter = undefined,
  onConfirm = () => {},
  onCancel = () => {},
  isMaskClosable = true,
  zIndex = 1000,
  forceRender = true,
  confirmLoading = false,
}: {
  isOpen: boolean;
  title: string;
  width: string | number;
  children: ReactNode;
  customFooter?: ReactNode | null | undefined;
  onConfirm?: React.MouseEventHandler<HTMLElement>;
  onCancel?: React.MouseEventHandler<HTMLElement>;
  isMaskClosable?: boolean;
  zIndex?: number;
  forceRender?: boolean;
  confirmLoading?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <Modal
      className="CustomModal"
      centered
      destroyOnClose
      open={isOpen}
      title={title}
      width={width}
      onCancel={onCancel}
      footer={
        customFooter !== undefined ? (
          customFooter
        ) : (
          <Button type="primary" onClick={onConfirm} loading={confirmLoading}>
            {t('Common.Determine')}
          </Button>
        )
      }
      maskClosable={isMaskClosable}
      zIndex={zIndex}
      forceRender={forceRender}
    >
      {children}
    </Modal>
  );
}

export default CustomModal;
